<template>
    <div>
        <div class="notification is-warning " v-if="loading==true">
            <p>Loading ...</p>
        </div>

        <div v-if="loading==false" class=" content">
            <div class="notification is-success " v-if="this.application.completed==1">
                <p>This application has been completed and can no longer be updated using this website.</p>
            </div>
            <div class="notification is-success " v-if="this.application.cleared==1">
                <p>Your application has been cleared and can no longer be updated using this website.</p>
            </div>
            <div class="notification is-danger " v-if="this.application.completed==0 && application.archived==1">
                <p>This application has been archived and can no longer be updated using this website.</p>
            </div>

            
            
            <div v-if="this.application.cleared ==0 && this.application.completed==0 && application.archived==0">
                <div class="notification is-info " v-if="this.application.status==1 || this.application.status==2">
                    <p>Your application is being processed by {{ system_title }}. We will respond by email to let you know what the next step is.</p>
                    <p>Please send us an email if you have any queries regarding your application.</p>
                </div>
                <div v-else>
                    
                    <div v-if="componentToView == ''">
                        <div class="notification is-warning content" v-if="this.application.status==0"> 
                            <p>Thank you for starting your application with {{ system_title }}. It has now been saved and you can return to update it at any time.</p>
                            <p>We require some further information before your application can proceed. Please click below to see the various sections we need filled in now.</p>
                            <p><strong>Once completed, press the green Return to Balmoral button to let us know you're ready for us to review your application.</strong></p>
                        </div>
                        <div v-else>
                            <p class="mb-3">You are required to complete the following sections. Please press each button, fill in the details and then save each section before pressing Return to Balmoral.</p>
                            
                        </div>
                        
                        
                        
                        <div class="columns buttons are-large">
                            <div class="column">
                                <button class="button is-danger is-fullwidth" @click="cancelApplication()">Cancel My Application</button>
                            </div>

                            <div class="column is-full " v-for="row in this.application.applicant_stages" :key="row.id">
                                <button class="button is-info is-fullwidth" @click="componentToView=row.component">{{ row.stage_name}} 
                                    <span class="icon ml-4" v-if="row.started==1">
                                        <font-awesome-icon icon="fa-solid fa-check" />
                                    </span>
                                </button>
                            </div> 
                            
                            <div class="column is-full">
                                <button class="button is-success is-fullwidth" @click="returnApplication()">{{ submit_button_text}}</button>
                                <small>Please make sure you have completed all sections as the application will be locked once you return it to us. It will be re-opened if we require more information from you.</small>
                            </div>
                        </div> 
                    </div>


                    <PersonalDetails v-if="componentToView=='personal'" application="application" @backToMenu="showMenu"/>

                    <Union v-if="componentToView=='union'" application="application" @backToMenu="showMenu"/>

                    <Education v-if="componentToView=='education'" application="application" @backToMenu="showMenu"/>

                    <SkillsSheet v-if="componentToView=='skills_sheet'" application="application" @backToMenu="showMenu"/>

                    <NurseSkillsSheet v-if="componentToView=='nurse_skills_sheet'" application="application" @backToMenu="showMenu"/>

                    <ParamedicSkillsSheet v-if="componentToView=='paramedic_skills_sheet'" application="application" @backToMenu="showMenu"/>

                    <SocialWorkSkillsSheet v-if="componentToView=='social_work_skills_sheet'" application="application" @backToMenu="showMenu"/>
                    
                    <Health v-if="componentToView=='health'" application="application" @backToMenu="showMenu"/>
                    
                    <BankDetails v-if="componentToView=='bank_details'" application="application" @backToMenu="showMenu"/>

                    <Nmc v-if="componentToView=='nmc'" application="application" @backToMenu="showMenu"/>

                    <Gmc v-if="componentToView=='gmc'" application="application" @backToMenu="showMenu"/>

                    <Niscc v-if="componentToView=='niscc'" application="application" @backToMenu="showMenu"/>

                    <Hcpc v-if="componentToView=='hcpc'" application="application" @backToMenu="showMenu"/>

                    

                    <EqualOpportunities v-if="componentToView=='equal_opportunities'" application="application" @backToMenu="showMenu"/>

                    <Interview v-if="componentToView=='interview'" application="application" @backToMenu="showMenu"/>

                    <WorkExperience v-if="componentToView=='work_experience'" application="application" @backToMenu="showMenu"/>

                    <EmploymentHistory v-if="componentToView=='employment_history'" application="application" @backToMenu="showMenu"/>

                    <References v-if="componentToView=='references'" application="application" @backToMenu="showMenu"/>

                    <AccessNiPolicy v-if="componentToView=='access_ni_policy'" application="application" @backToMenu="showMenu"/>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import UtilityService from '@/services/UtilityService.js';

    import BankDetails from '@/components/BankDetails.vue'
    import Nmc from '@/components/Nmc.vue'
    import Gmc from '@/components/Gmc.vue'
    import Niscc from '@/components/Niscc.vue'
    import Hcpc from '@/components/Hcpc.vue'
    import AccessNiPolicy from '@/components/AccessNiPolicy.vue'
    import Health from '@/components/Health.vue'
    import PersonalDetails from '@/components/PersonalDetails.vue'
    import Union from '@/components/Union.vue'
    import EqualOpportunities from '@/components/EqualOpportunities.vue'
    import Interview from '@/components/Interview.vue'
    import WorkExperience from '@/components/WorkExperience.vue'
    import EmploymentHistory from '@/components/EmploymentHistory.vue'
    import Education from '@/components/Education.vue'
    import SkillsSheet from '@/components/SkillsSheet.vue'
    import NurseSkillsSheet from '@/components/NurseSkillsSheet.vue'
    import ParamedicSkillsSheet from '@/components/ParamedicSkillsSheet.vue'
    import SocialWorkSkillsSheet from '@/components/SocialWorkSkillsSheet.vue'
    import References from '@/components/References.vue'

    export default {
      name: 'ViewApplication',
        mixins: [],
        components: {
            BankDetails,
            Nmc,
            Gmc,
            AccessNiPolicy,
            PersonalDetails,
            Union,
            Health,
            EqualOpportunities,
            Interview,
            WorkExperience,
            Niscc,
            Hcpc,
            Education,
            SkillsSheet,
            NurseSkillsSheet,
            ParamedicSkillsSheet,
            SocialWorkSkillsSheet,
            EmploymentHistory,
            References
        },
        data: function () {
            return {
                   application_code : this.$route.params.id,
                   loading:false,
                   application: [],
                   accessToken: '',
                   componentToView: '',
                   submit_button_text: 'Return to Balmoral',
                   system_title : process.env.VUE_APP_SYSTEM_TITLE,
            }
        },
        created() {
          //this.getAccessToken()
          //  .then(() => { 
          //      console.log(this.application_code)
                this.getApplication()
          //  });
          
        },
        methods: {
            showMenu() {
                this.componentToView = ''
                this.getApplication()
            },
            async returnApplication() {
                if(confirm('Please make sure you have completed and saved all of the sections before returning your application ?'))
                {
                    this.loading = true;
                    UtilityService.postSimpleApiData(this.accessToken, "web/applications/" + this.application_code + '/return').then(
                        response => {
                            this.application = response 
                            this.loading = false;
                        }
                    );
                }
            },
            async cancelApplication() {
                if(confirm('Are you sure you want to cancel this application ? If you wish to apply again, you will need to start a new application process.'))
                {
                    this.loading = true;
                    UtilityService.postSimpleApiData(this.accessToken, "web/applications/" + this.application_code + '/cancel').then(
                        response => {
                            this.application = response 
                            this.loading = false;
                        }
                    );
                }
            },
            async getApplication() {
                this.loading = true;
                UtilityService.getSimpleApiData(this.accessToken, "web/applications/" + this.application_code).then(
                    response => {
                        this.application = response 
                        this.loading = false;
                    }
                );
            },
            
           
        }
    }
    </script>